import { create } from 'zustand';

export interface PlaybackState {
    currentTime: number;
    isPlaying: boolean;
    setCurrentTime: (t: number) => void;
    setIsPlaying: (p: boolean) => void;
}

export const usePlaybackStore = create<PlaybackState>((set) => ({
    currentTime: 0,
    isPlaying: false,
    setCurrentTime: (t) => set({ currentTime: t }),
    setIsPlaying: (p) => set({ isPlaying: p }),
}));
